import React from 'react';

export default class SearchInput extends React.Component {
  render() {
    return (
      <form className="hs-form-field" id="cse-search-box" onSubmit={this.props.formSubmission}>
        <input type="text" name="q" placeholder="Search" value={this.props.query} onChange={this.props.queryChanged} />
        <input type="submit" name="sa" value="Search" className="hs-button" />
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/SearchInput.js